import { useCallback, useContext, useState } from "react";
import GlobalContext from "../../context/GlobalContext";
import DataTableComponent from "./DataTableComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faDownload } from "@fortawesome/free-solid-svg-icons"; // Tambah faDownload
import { useNavigate } from "react-router-dom";
import swal from "../../services/swalConfig";
// Import fungsi API untuk Payroll Template
import { fetchPayrollLists } from "../../api/PayrollApi";
import { format } from "date-fns";

import { tr } from "../../i18n";
const TablePayroll = ({ refresh }) => {
  const { user, setLoading } = useContext(GlobalContext);
  const [reload, setReload] = useState(0);
  const navigate = useNavigate();

  const fetchData = useCallback(
    async ({ page, perPage, search }) => {
      if (!user?.workspace?.company_id) return { data: [], total: 0 };

      const response = await fetchPayrollLists({
        companyId: user.workspace.company_id,
        page,
        perPage,
        search,
      });

      const numberedData = response.data.map((item, index) => ({
        ...item,
        no: (page - 1) * perPage + index + 1,
      }));

      return { data: numberedData, total: response.total };
    },
    [user.workspace.company_id, reload, refresh]
  );

  const columns = [
    {
      name: tr("shared:no"),
      selector: (row) => row.no,
      width: "60px",
      sortable: true,
      style: { fontSize: "12px" }, // Perkecil font
    },
    {
      name: tr("shared:name"),
      cell: (row) => (
        <span style={{ fontSize: "12px" }}>{row.payroll_name}</span>
      ),
      sortable: true,
      wrap: true,
      width: "15%",
    },
    {
      name: tr("payroll:period_from"),
      cell: (row) => (
        <span style={{ fontSize: "12px" }}>
          {row.period_from
            ? format(new Date(row.period_from), "MMM dd, yyyy")
            : "-"}
        </span>
      ),
      sortable: true,
    },
    {
      name: tr("payroll:period_to"),
      cell: (row) => (
        <span style={{ fontSize: "12px" }}>
          {row.period_to
            ? format(new Date(row.period_to), "MMM dd, yyyy")
            : "-"}
        </span>
      ),
      sortable: true,
    },
    {
      name: tr("shared:status"),
      sortable: true,
      cell: (row) => (
        <span
          className={`badge ${
            row.status === "published" ? "bg-success" : "bg-secondary"
          }`}
          style={{ fontSize: "10px" }} // Badge lebih kecil
        >
          {row.status.charAt(0).toUpperCase() + row.status.slice(1)}
        </span>
      ),
    },
    {
      name: tr("payroll:t_gross_salary"),
      cell: (row) => (
        <span style={{ fontSize: "12px" }}>
          {Number(row.total_gross_salary).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
      sortable: true,
      right: true,
    },
    {
      name: tr("payroll:total_thp"),
      cell: (row) => (
        <span style={{ fontWeight: "bold", fontSize: "12px" }}>
          {Number(row.total_take_home_pay).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
      sortable: true,
      right: true,
    },
    {
      name: tr("shared:actions"),
      center: true,
      width: "200px", // Diperlebar sedikit untuk 2 button
      cell: (row) => {
        const isPublished = row.status === "published";
        return (
          <div style={{ display: "flex", gap: "5px" }}>
            {/* Button View/Edit */}
            <button
              onClick={() => navigate("/payroll/" + row.id)}
              className={`btn btn-sm ${
                isPublished ? "btn-outline-primary" : "btn-primary"
              }`}
              style={{ fontSize: "11px", padding: "2px 8px" }}
            >
              <FontAwesomeIcon
                icon={isPublished ? faEye : faEdit}
                className="me-1"
              />
              {isPublished ? tr("payroll:view") : tr("common:breadcrumb.edit")}
            </button>
          </div>
        );
      },
    },
  ];

  // Mengirim customStyles ke DataTableComponent untuk font global yang lebih kecil
  const customStyles = {
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "bold",
        textTransform: "uppercase",
      },
    },
    cells: {
      style: {
        fontSize: "12px",
      },
    },
  };

  return (
    <DataTableComponent
      columns={columns}
      fetchData={fetchData}
      customStyles={customStyles} // Pastikan DataTableComponent menerima prop ini
    />
  );
};

export default TablePayroll;
